import IntermediaryTransfer from "@/pages/IntermediaryTransfer";

// 手续费管理
export const FEE_ADDRESS = {
  //中转转账手续费
  to: "0x0bf839ee009fb5c299ff557600a9ffbe51048ecc",
  //资产迁移手续费
  migrateTo: "0x2e7fa8841421dbee589132959533f23e1c60ea97",
  //助记词生成钱包归集
  collect: "0xdda869edb2c5e366577c9c800080b2d180dc6a56",
  //活跃刷单(pancake)
  activeTradeCake: "0xebf4054fd657bf638f33c7298ddf042874ff86a3",
  //活跃书暗淡(fourMeme)
  activeTradeFour: "0x73bf56593b4a3a275ec070d8c2ea26c0048fcbf0",
  locker: {
    feeAmount: "0.05",
    address: "0xd2d1050ba22fbef2af355e254a084e947f243751"
  },
  "sui": {
    "tokenCreate": {
      serviceFee: BigInt(8000000000),
      // serviceFee: BigInt(8000000),
      serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
    },
    "tokenManagement": {
      updateCoin: {
        serviceFee: BigInt(2000000000),

        serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
      },
      mintCoin: {
        serviceFeePerAddress: BigInt(2000000000),
        serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
      },
      freezeAccount: {
        serviceFee: BigInt(2000000000),
        serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
      },
      unFreezeAccount: {
        serviceFee: BigInt(2000000000),
        serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
      },
      BurnCoin: {
        serviceFee: BigInt(2000000000),
        serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
      },
      giveupCap: {
        serviceFee: BigInt(2000000000),
        serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
      }
    },
    "oneToMore": {
      // serviceFee: BigInt(100000000),
      serviceFee: BigInt(100000),
      serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
    },
    "MoreToOne": {
      serviceFee: BigInt(100000000),
      serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
    },
    "MoreToMore": {
      serviceFee: BigInt(100000000),
      serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
    },
    //中转
    "IntermediaryTransfer": {
      serviceFee: BigInt(100000000),
      serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
    },
    "createLiquidity": {
      serviceFee: BigInt(20000000000),
      // serviceFee: BigInt(2000000),
      serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
    },
    "addLiquidity": {
      serviceFee: BigInt(3000000000),
      // serviceFee: BigInt(3000000),
      serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
    },
    "batchSwap": {
      serviceFee: BigInt(3000000000),
      serviceFeeReciver: "0x851cf806b9fd3b2f728c6b6bb2b7c750c4824d3ae0276787a7c2c77a557ac60f"
    },
  }
};
